import { toast } from 'sonner';

export const showToast = (message, type = 'default') => {
  const options = {
    position: 'top-right',
    duration: 2000,
  };

  switch (type) {
    case 'success':
      toast.success(message, options);
      break;
    case 'error':
      toast.error(message, options);
      break;
    case 'warning':
      toast.warning(message, options);
      break;
    case 'info':
      toast.info(message, options);
      break;
    default:
      toast(message, options);
  }
};
